import { useState, type ChangeEvent, type FC } from "react";
import { TaskItem } from "../TaskItem/TaskItem";
import "./Tasklist.scss";
import type { TasksArr } from "../../main";

interface ITaskListProps {
  tasks: TasksArr;
  onDone: (id: number) => void;
  onChangeTask: (id: number) => void;
  onDelete: (id: number) => void;
  onDeleteComplited: () => void;
  onSortList: () => void;
}

export const TaskList: FC<ITaskListProps> = ({ tasks, onDone, onChangeTask, onDelete, onDeleteComplited, onSortList }) => {
  /* useState для фильтрации списка */
  const [filterString, setFilterString] = useState("");
  const [filterStatus, setFilterStatus] = useState("all")

  const handleFilter = (e: ChangeEvent<HTMLInputElement>) => {
    setFilterString(e.target.value);
  };

  const handleStatusFilter = (status: "all" | "active" | "completed") => {
    setFilterStatus(status);
  };

  const handleBtnDone = (id: number) => {
    onDone(id)
  };

  /* новый массив для фильтрации списка */
  const filterList = tasks.filter((task) => {
    const taskMatchesFilter = task.task.toLowerCase().includes(filterString.toLowerCase());
    const statusMatchesFilter =
      filterStatus === "all" ||
      (filterStatus === "active" && !task.done) ||
      (filterStatus === "completed" && task.done);
    console.log(filterStatus);
    return taskMatchesFilter && statusMatchesFilter;
  })

  /* Подсчёт оставщихся задач */
  const activeTaskCount = tasks.filter(task => !task.done).length;

  /* Clear completed */
  const handleDeleteComplited = () => {
    if (confirm("Вы уверены?")) {
      onDeleteComplited()
    }
  }

  return (
    <>
      {tasks.length >= 1 ? (
        <>
          <div className="task__top">
            <input className="task__top-search" value={filterString} onChange={handleFilter} placeholder="Поиск задачи" type="text" name="search"></input>
            <button className="task__top-sort" onClick={() => onSortList()}>
              <svg width="800px" height="800px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 5H3L3 16H5L5 5L8 5V4L4 0L0 4V5Z" />
                <path d="M8 11L11 11L11 0H13L13 11H16V12L12 16L8 12V11Z" />
              </svg>
            </button>
          </div>
          <ul className="task__list">
            {filterList.map(({ id, task, done }) => (
              <li onClick={() => handleBtnDone(id)} className={!done ? "task__item" : "task__item done"} key={id}>
                <TaskItem
                  id={id}
                  taskTitle={task}
                  onChangeTask={onChangeTask}
                  onDelete={onDelete}
                />
              </li>
            ))}
          </ul>
          <div className="task__bottom">
            <span>Кол-во оставшихся задач: {activeTaskCount}</span>
            <div className="task__bottom-block">
              <button className={`task__bottom-btn ${filterStatus === "all" ? "active" : ""}`} onClick={() => handleStatusFilter("all")}>All</button>
              <button className={`task__bottom-btn ${filterStatus === "active" ? "active" : ""}`} onClick={() => handleStatusFilter("active")}>Active</button>
              <button className={`task__bottom-btn task__bottom-btn_completed ${filterStatus === "completed" ? "active" : ""}`} onClick={() => handleStatusFilter("completed")}>Completed</button>
            </div>
            <button className="task__bottom-btn task__bottom-btn_clear" onClick={handleDeleteComplited}>Clear completed</button>
          </div>
        </>
      ) : (
        <div className="empty">
          ЗАДАЧИ ОТСУТСТВУЮТ
        </div>
      )
      }
    </>
  )
}



